// extracted by mini-css-extract-plugin
module.exports = {"main":"RichiestaManualiTemplate_main__NbaHz","rotation":"RichiestaManualiTemplate_rotation__73REo"};